import React, { PropsWithChildren } from 'react';
import cx from 'classnames';
import { Tooltip } from 'antd';
import { MdCompareArrows } from 'react-icons/md';
import Panel from '../../../../components/outline/Panel';
import './ProductDetailPanel.scss';

interface ProductDetailPanelProps {
  className?: string;
  name: string;
  title: string;
  subTitle?: string;
  isCompare?: boolean;
  scrollToTargetPanel?: (name: string) => void;
  sectionId?: string;
}

const ProductDetailPanel = (props: PropsWithChildren<ProductDetailPanelProps>): JSX.Element => {
  const {
    className,
    name,
    title,
    subTitle,
    children,
    isCompare = false,
    scrollToTargetPanel,
    sectionId,
    ...res
  } = props;
  return (
    <Panel
      className={cx('product-detail-panel', className)}
      name={`${sectionId ? sectionId + '-' : ''}${name}`}
      {...res}
    >
      <div className={cx('panel-header', subTitle && 'sub-title-header')}>
        <div className="title">
          <span>{title}</span>
          {subTitle ? <span className="sub-title">{subTitle}</span> : null}
        </div>

        {isCompare && (
          <Tooltip title={`${title} 비교하기`}>
            <MdCompareArrows
              data-testid={`compare-arrow-${name}`}
              onClick={() => scrollToTargetPanel && scrollToTargetPanel(name)}
            />
          </Tooltip>
        )}
      </div>

      {children}
    </Panel>
  );
};

export default ProductDetailPanel;
